import PermissionsPage from './PermissionsPage';

export default PermissionsPage;
